import { Flex, ToogleSwitch, Hint } from "/app/src/component";
import _ from "underscore";
import React from "react";
import PaymentConfigHandler from '/app/src/config/PaymentConfigHandler'

export default ({ ratingOn, setRatingOn }) => {
  const toogleSwitch = {
    on: ratingOn,
    manual: true,
    onChange: () => {
      console.log("changed ratingon:", ratingOn)
      setRatingOn(!ratingOn);
    },
  };
  const label = {
    color: "black",
    fontSize: "24px",
    fontWeight: "300",
    my: "5px",
  };
  const labelHint = {
    style: { marginTop: "7px", marginLeft: "10px" },
    position: "top",
    tooltip:
      "Vid avslutad chatt kommer besökaren att få möjligheten att betygsätta konversationen. Då denna funktionalitet är i beta-stadiet kan det förekomma buggar.",
  };

  console.log(PaymentConfigHandler.checkAccess('feature-rating', 'read') === 'unlimited')
  console.log(PaymentConfigHandler.checkAccess('feature-rating', 'read') === 'unlimited' ? "false": "true")
  return (
    <Flex w="100%" shrink={0}>
      <Flex basis="20%" pt="40px">
        <ToogleSwitch {...toogleSwitch} disable={PaymentConfigHandler.checkAccess('feature-rating', 'read') === 'unlimited' ? false : true} disableReason="Uppgradera till PRO för utökad funktionalitet" color="black" hover="blue" height="60px"/>
      </Flex>
      <Flex basis="80%" column>
        <Flex {...label}>
           Betygsättning <Hint {...labelHint} />
        </Flex>
        <Flex color="black" fontSize="18px" my="5px" column>
          Aktivera betygssättning för besökaren.
        </Flex>
      </Flex>
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Rating/_RatingToggle.js